import React from "react";

function Logo(props) {
    return(
        <img className="logo-img" src={"/assets/img/logos/"+props.type+".png"} alt={"Logo "+props.type} />
    )
}

export default Logo;